export const UnwrapTxConfirmationEventName = "UnwrapWethTxConfirmation" as const;
export const UnwrapTxErrorEventName = "UnwrapWethTxError" as const;
export const UnwrapTxHashEventName = "UnwrapWethTxHash" as const;
export const UnwrapTxReceiptEventName = "UnwrapWethTxReceipt" as const;
export const WrapTxConfirmationEventName = "WrapEthTxConfirmation" as const;
export const WrapTxErrorEventName = "WrapEthTxError" as const;
export const WrapTxHashEventName = "WrapEthTxHash" as const;
export const WrapTxReceiptEventName = "WrapEthTxReceipt" as const;
